import { poller } from "@shared/services";
import React, { useEffect, useState } from "react";
import tinytime from "tinytime";

import { LanguagePopup } from "../Popup/LanguagePopup";

const timezone = Math.abs(new Date().getTimezoneOffset() / 60);
const timeTemplate = tinytime(`{H}:{mm} GMT+${timezone} {DD}.{Mo}.{YYYY}`);

const Top = () => {
  const [time, setTime] = useState(timeTemplate.render(new Date()));

  useEffect(() => {
    const { disposeCallback } = poller.poll(() => {
      const date = new Date();
      setTime(timeTemplate.render(date));
    }, 5000);

    return () =>
      typeof disposeCallback === "function" ? disposeCallback() : null;
  }, []);

  return (
    <div className="header__top">
      <ul className="submenu">
        <LanguagePopup />
      </ul>

      <div className="header__time">{time}</div>
    </div>
  );
};

export default React.memo(Top);
